import script from "./ErrorModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorModal.vue?vue&type=script&setup=true&lang=js"

import "./ErrorModal.vue?vue&type=style&index=0&id=59b17900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59b17900"]])

export default __exports__